import { withFields } from 'app-webtech-core/beacon/withFields';
import { uiLoadedBeacon } from './uiLoaded';
import { sectionSelectBeacon } from './sectionSelect';
import { UI_LOADED, SECTION_SELECT } from '../actions/types';

export const layoutEventDefinitionsMap = {
  [UI_LOADED]: withFields(uiLoadedBeacon),
  [SECTION_SELECT]: withFields(sectionSelectBeacon),
};
